<template>

    <div class="container">

        <app-head title="Synonyms" />

        <div class="d-flex justify-content-start align-items-center mb-3 gap-3">
            <h1 class="">{{ __('Synonyms') }}</h1>
            <div class="">
                <inertia-link class="btn btn-primary" :href="route('admin.synonyms.create')">
                    {{ __('Create') }}
                </inertia-link>
            </div>
        </div>

        <div class="d-flex mb-3">
            <search-filter v-model="form.search" class="" @reset="reset">
            </search-filter>
        </div>

        <div class="d-flex justify-content-between">
            <results :meta="synonyms.meta" />
        </div>

        <div class="card">
            <data-table :items="synonyms.data"
                        :links="synonyms.meta.links"
                        :columns="columns"
                        >
                <data-table-row v-for="synonym in synonyms.data" :key="synonym.id">
                    <td>
                        {{ synonym.id }}
                    </td>
                    <td>
                        <inertia-link class="d-flex flex-wrap gap-2 stretched-link" :href="route('admin.synonyms.edit', synonym)">
                            <span class='' v-for="term in synonym.terms">{{ term }} </span>
                        </inertia-link>
                    </td>
                    <td>
                        {{ synonym.notes || '-' | truncateWords }}
                    </td>
                    <td class="text-end">
                        <i class="bi bi-chevron-right"></i>
                    </td>
                </data-table-row>
            </data-table>
        </div>

    </div>

</template>

<script>

    import DataTable from '@/shared/Admin/DataTable';
    import DataTableRow from '@/shared/Admin/DataTableRow';
    import SearchFilter from '@/shared/Admin/SearchFilter';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import Results from '@/shared/Admin/Results';


    export default {
        props: {
            filters: Object,
            synonyms: Object,
        },
        components: {
            DataTable,
            DataTableRow,
            SearchFilter,
            SelectInput,
            Results,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    status: this.filters.status,
                },
                columns: {
                    id: {label: 'ID', sortable: 'id'},
                    terms: {label: 'Terms', sortable: 'terms'},
                    notes: {label: 'Notes'},
                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: _.debounce(function () {
                    this.$inertia.get(this.route('admin.synonyms.index'), this.form, {preserveState: true})
                }, 300, {trailing: true}),
            },
        },
        methods: {
            reset() {
                this.form = _.mapValues(this.form, () => null)
            },
        },
    }
</script>